<template>
    <div>
        <img class="object-fill rounded-full bg-blue-100" :class="sizeClasses" :src="path" v-if="path" />
        <div class="rounded-full bg-cyan-100 text-cyan-700 font-semibold flex items-center justify-center select-none" :class="[sizeClasses, textSizeClass]" v-else-if="initials">{{ initials }}</div>
        <div class="rounded-full bg-blue-100" :class="sizeClasses" v-else></div>
    </div>
</template>

<script>
import { computed } from 'vue';

export default {
    props: {
        path: String,
        size: String,
        name: String
    },
    setup(props) {
        const sizeClasses = computed(() => ({
            'w-10 h-10': props.size === 'small',
            'w-14 h-14': !props.size,
            'w-20 h-20': props.size === 'large',
            'w-28 h-28': props.size === 'extra-large'
        }));

        const textSizeClass = computed(() => {
            if (props.size === 'small') return 'text-sm';
            if (props.size === 'large') return 'text-xl';
            if (props.size === 'extra-large') return 'text-3xl';
            return 'text-base';
        });

        const initials = computed(() => {
            if (!props.name) return '';
            const parts = props.name.trim().split(/\s+/).filter(Boolean);
            if (!parts.length) return '';
            const first = parts[0][0] || '';
            const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
            return (first + last).toUpperCase();
        });

        return { sizeClasses, textSizeClass, initials };
    }
}
</script>
